<template>
  <div class="wl-edit">
    <b-overlay :show="loading">
      <wine-list-header
        :title="active_list.list_title"
        :saving="saving"
        :uncommitted="uncommitted"
        subtitle="Editing"
        show-settings
        :slug="active_list.slug"
        :last-edited="{
          date: active_list.updated_at,
          name: active_list.updated_by,
        }"
      ></wine-list-header>
      <div class="container-lg">
        <div class="row">
          <div class="col-12">
            <b-nav tabs>
              <b-nav-item
                :to="'/edit/price-list/' + active_list.slug"
                :active="active_template === 'price-list'"
                v-if="
                  is_template_enabled('PRICE-YP') ||
                  is_template_enabled('PRICE-SELL') ||
                  is_template_enabled('PRICE-GLASS')
                "
                >Price List</b-nav-item
              >
              <b-nav-item
                :to="'/edit/brochure/' + active_list.slug"
                :active="active_template === 'brochure'"
                v-if="is_template_enabled('BROCHURE')"
                >Interactive Fact Sheet</b-nav-item
              >
              <b-nav-item
                :to="'/edit/wine-tasting/' + active_list.slug"
                :active="active_template === 'wine-tasting'"
                v-if="is_template_enabled('TASTING')"
                >Tasting Booklet</b-nav-item
              >
            </b-nav>
            <div class="wl-action-bar mb-3">
              <div class="row">
                <div class="col-12">
                  <b-nav small align="left">
                    <!-- <b-nav-item title="Order Samples" v-if="isStaff">
                      Order Samples
                    </b-nav-item> -->
                    <b-nav-item
                      title="Preview"
                      :to="'/view/' + active_list.slug"
                      >Preview</b-nav-item
                    >
                    <b-nav-item title="Share" v-b-modal.modal-list-share
                      >Share</b-nav-item
                    >
                    <b-nav-item
                      title="Download PDF"
                      :href="pdf_url"
                      target="_blank"
                      >Download PDF</b-nav-item
                    >
                    <b-nav-item
                      title="Download XLS"
                      v-if="active_template === 'price-list'"
                      :href="
                        '/download/wine-list/xls/price-list?id=' +
                        active_list.slug
                      "
                      target="_blank"
                      >Download XLS</b-nav-item
                    >
                    <b-nav-item
                      v-if="presentation_mode && isStaff"
                      @click="
                        $store.commit('winelist/set_presentation_mode', false)
                      "
                      title="Presentation Mode"
                      >Presentation Mode: On</b-nav-item
                    >
                    <b-nav-item
                      v-else-if="isStaff"
                      @click="
                        $store.commit('winelist/set_presentation_mode', true)
                      "
                      title="Presentation Mode"
                      >Presentation Mode: Off</b-nav-item
                    >
                  </b-nav>
                </div>
              </div>
            </div>

            <price-list
              v-if="
                active_template === 'price-list' &&
                (is_template_enabled('PRICE-YP') ||
                  is_template_enabled('PRICE-SELL') ||
                  is_template_enabled('PRICE-GLASS'))
              "
              :enabled-yp="is_template_enabled('PRICE-YP')"
              :enabled-sell="is_template_enabled('PRICE-SELL')"
              :enabled-glass="is_template_enabled('PRICE-GLASS')"
              :value-yp="get_template('PRICE')"
              :value-sell="get_template('PRICE')"
              :value-glass="get_template('PRICE')"
              :presentation-mode="presentation_mode"
              :editable="isStaff ? true : active_list.customer_editable === '1'"
              @change="set_template($event.template, $event.data)"
              :slug="active_list.slug"
              @update-order="update_order"
              @hide-item="hide_item"
              @update-item="update_item"
              @remove-item="remove_item"
              :target-margin="active_list.target_margin"
              :target-margin-glass="active_list.target_margin_glass"
            ></price-list>

            <interactive-brochure
              v-if="
                active_template === 'brochure' &&
                is_template_enabled('BROCHURE')
              "
              :value="get_template('BROCHURE')"
              :slug="active_list.slug"
              :presentation-mode="presentation_mode"
              :editable="isStaff ? true : active_list.customer_editable === '1'"
              @change="set_template('BROCHURE', $event)"
              @update-order="update_order"
              @hide-item="hide_item"
              @update-item="update_item"
              @remove-item="remove_item"
            ></interactive-brochure>

            <wine-tasting
              v-if="
                active_template === 'wine-tasting' &&
                is_template_enabled('TASTING')
              "
              :value="get_template('TASTING')"
              :slug="active_list.slug"
              :presentation-mode="presentation_mode"
              :editable="isStaff ? true : active_list.customer_editable === '1'"
              @change="set_template('TASTING', $event)"
              @update-order="update_order"
              @hide-item="hide_item"
              @update-item="update_item"
              @remove-item="remove_item"
              :hide-glass="!is_template_enabled('PRICE-GLASS')"
            ></wine-tasting>
          </div>
        </div>
      </div>
    </b-overlay>
    <wine-list-share :list-slug="active_list.slug"></wine-list-share>
  </div>
</template>

<script>
import PriceList from "@/components/winelist/WineListPriceList";
import InteractiveBrochure from "@/components/winelist/WineListBrochure";
import WineTasting from "@/components/winelist/WineListTasting";
import WineListHeader from "@/components/winelist/WineListHeader";
import WineListShare from "@/components/winelist/WineListShare";

import { mapState, mapGetters } from "vuex";

export default {
  components: {
    PriceList,
    InteractiveBrochure,
    WineTasting,
    WineListHeader,
    WineListShare,
  },
  data() {
    return {
      id: "",
      active_template: "",
      loading: true,
    };
  },
  mounted() {
    this.id = this.$route.params.id;
    this.$store
      .dispatch("winelist/load_and_activate_full_list", this.id)
      .then(() => {
        this.loading = false;
        this.updateNavigation();
      });
  },
  methods: {
    set_template(template, items) {
      this.$store.commit("winelist/update_template", {
        template,
        items,
      });
    },
    update_item(data) {
      this.$store.dispatch("winelist/update_item", {
        id: this.active_list.id,
        ...data,
      });
    },
    hide_item(evt) {
      this.$store.dispatch("winelist/hide_item", {
        id: this.active_list.id,
        template: evt.template,
        ...evt.data,
      });
    },
    update_order(evt) {
      this.$store.dispatch("winelist/update_order", {
        id: this.active_list.id,
        template: evt.template,
        ...evt.data,
      });
    },
    remove_item(evt) {
      this.$bvModal
        .msgBoxConfirm("Are you sure you want to remove this item?")
        .then((state) => {
          if (state) {
            this.$store.dispatch("winelist/remove_item", {
              id: this.active_list.id,
              ...evt,
            });
          }
        });
    },
    updateNavigation() {
      if (this.$route.params.template) {
        this.active_template = this.$route.params.template;
      } else {
        if (
          this.is_template_enabled("PRICE-YP") ||
          this.is_template_enabled("PRICE-SELL") ||
          this.is_template_enabled("PRICE-GLASS")
        ) {
          this.$router.replace("/edit/price-list/" + this.id);
          return;
        }
        if (this.is_template_enabled("BROCHURE")) {
          this.$router.replace("/edit/brochure/" + this.id);
          return;
        }
        if (this.is_template_enabled("TASTING")) {
          this.$router.replace("/edit/wine-tasting/" + this.id);
          return;
        }
      }
    },
  },
  watch: {
    "$route.params.template"() {
      this.updateNavigation();
    },
  },
  computed: {
    ...mapState("winelist", [
      "active_list",
      "uncommitted",
      "saving",
      "presentation_mode",
    ]),
    ...mapGetters("winelist", ["is_template_enabled", "get_template"]),
    pdf_url() {
      switch (this.active_template) {
        case "brochure":
          return "/download/wine-list/pdf/brochure?id=" + this.active_list.slug;
        case "wine-tasting":
          return "/download/wine-list/pdf/tasting?id=" + this.active_list.slug;
        case "price-list":
          return (
            "/download/wine-list/pdf/price-list?id=" + this.active_list.slug
          );
      }

      return "";
    },
  },
};
</script>
